'use client';

import { Button } from 'flowbite-react';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { HiHome } from 'react-icons/hi';

export default function NotFound() {
	const router = useRouter();

	useEffect(() => {
		// Menonaktifkan sidebar dengan menambahkan class ke body
		document.body.classList.add('sidebar-disabled');
		document.body.classList.add('not-found-page');

		// Cleanup function
		return () => {
			document.body.classList.remove('sidebar-disabled');
			document.body.classList.remove('not-found-page');
		};
	}, []);

	return (
		<div className="not-found-container min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 relative overflow-hidden">
			{/* Bubble background */}
			<span
				className="bubble bubble-blue"
				style={{ top: '10%', left: '15%' }}
			/>
			<span
				className="bubble bubble-blue-light"
				style={{ top: '80%', left: '10%' }}
			/>
			<span
				className="bubble bubble-blue"
				style={{ top: '80%', left: '70%' }}
			/>
			<span
				className="bubble bubble-blue-light"
				style={{ top: '10%', left: '80%' }}
			/>
			<div className="text-center relative z-10">
				<h1 className="text-9xl font-extrabold text-blue-600 dark:text-blue-500 mb-4 animate-bounce">
					404
				</h1>
				<div className="mb-8">
					<h2 className="text-3xl font-bold text-blue-600 dark:text-white mb-2">
						Halaman Tidak Ditemukan
					</h2>
					<p className="text-gray-600 dark:text-gray-400">
						Halaman yang dituju tidak ditemukan. Silahkan Kembali ke halaman utama.
					</p>
				</div>
				<div className="flex justify-center">
					<Button
						size="lg"
						onClick={() => router.push('/')}
						className="justify-center"
					>
						<HiHome className="mr-2 h-5 w-5" />
						Kembali
					</Button>
				</div>
			</div>
		</div>
	);
}
